import { render, staticRenderFns } from "./AdvisorsContent.vue?vue&type=template&id=dee3f220&scoped=true&"
import script from "./AdvisorsContent.vue?vue&type=script&lang=js&"
export * from "./AdvisorsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee3f220",
  null
  
)

export default component.exports